<template>
    <head>
        <meta charset="UTF-8">
        <title> | Habilite-se</title>
    </head>
  <div class="container-fluid">
    <div class="card shadow-sm">
      <div class="card-header">
        <h3 class="card-title"><span class="fa fa-desktop"></span>&nbsp;&nbsp; Verificar variáveis</h3>
      </div>
      <div class="card-header">
        <div class="row">
          <div class="col-md-12 my-5">
            <h6>Nome do template: </h6>{{ props.file_name }}
          </div>
        </div>
        <div>
          <button class="m-5 btn btn-success" @click="downloadFile" :disabled="isLoading">
            <span v-if="isLoading">Carregando...</span>
            <span v-else><span class="fas fa-download mr-2"></span>&nbsp;Download</span>
          </button>
          <a :href="props.url_back_page" class=" m-5 btn btn-secondary"><i class="fa fa-reply"></i>&nbsp;Voltar</a>
        </div>
      </div>
      <div class="card-body">
        <div v-if="props.document_macros?.length" class="alert alert-info">
          <strong>Macros encontradas no documento:</strong>
          <small class="d-block text-muted">(apenas para referência/depuração)</small>
          <div style="max-height: 90px; overflow:auto" class="mt-2">
            <code v-for="m in props.document_macros" :key="m" class="me-2">${{ m }}</code>
          </div>
        </div>

        <h5 class="mb-3">1) Macros usadas neste documento (serão preenchidas)</h5>
        <div class="table-responsive">
          <table class="table table-striped gy-5 gs-5">
            <thead>
              <tr>
                <td>
                  Descrição
                </td>
                <td>
                  Valor de referencia
                </td>
                <td>
                  Código
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="list in props.list" class="fw-bold fs-6  border-bottom-2 border-gray-200" :class="list.reference === '-' ? 'text-danger' : 'text-gray-800'">
                <td> {{ list.description }}</td>
                <td> {{ list.reference }}</td>
                <td>
                  <span v-pre>
                    ${</span>{{ list.code }}<span v-pre>}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="mt-6">
          <h5 class="mb-3">2) Macros disponíveis mas NÃO usadas neste documento</h5>
          <div v-if="!props.unused_list?.length" class="text-muted">Nenhuma</div>
          <div v-else class="table-responsive">
            <table class="table table-striped gy-5 gs-5">
              <thead>
                <tr>
                  <td>Descrição</td>
                  <td>Valor de referencia</td>
                  <td>Código</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in props.unused_list" :key="item.code" class="fw-bold fs-6 text-gray-600 border-bottom-2 border-gray-200">
                  <td>{{ item.description }}</td>
                  <td>{{ item.reference }}</td>
                  <td>
                    <span v-pre>
                      ${</span>{{ item.code }}<span v-pre>}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import axios from 'axios';
import { ref } from 'vue';


interface list {
  code: string,
  reference: string,
  description: string,
  category: string,
}

const props = defineProps({
  list: { type: Array<list>, required: true },
  unused_list: { type: Array<list>, required: false, default: () => [] },
  document_macros: { type: Array<string>, required: false, default: () => [] },
  file_name: { type: String, required: true },
  route_download: { type: String, required: true },
  url_back_page: { type: String, required: true },
})


const isLoading = ref(false);

function downloadFile() {
  isLoading.value = true;
  axios.get(props.route_download)
    .then(response => {
      const downloadUrl = response.data.downloadUrl;
      window.open(downloadUrl, '_blank');
    })
    .catch(error => {
      console.error('Error downloading document:', error);
    }).finally(() => {
      isLoading.value = false;
    });

}
</script>
